import React from 'react';

const defaultAttributes = [
  {
    label: 'Name',
    key: 'Name'
  },
  {
    label: 'Name',
    key: 'Name of Agency'
  },
  {
    label: 'Organization',
    key: 'Organization or agency'
  },
  {
    label: 'Address',
    key: 'Address'
  },
  {
    label: 'Telephone',
    key: 'Telephone number'
  },
  {
    label: 'E-mail',
    key: 'Email'
  }
];

class NationalContactsContentItem extends React.PureComponent {
  renderAttributes(data) {
    return defaultAttributes.map((item, index) => {
      const value = data[item.key];

      if (!value) return null;

      return (
        <div key={ index } className="national-contacts__item-info">
          <strong>{ item.label }:</strong> { value }
        </div>
      );
    });
  }

  render() {
    const { content, section, sameMessage } = this.props;

    return (
      <div className="national-contacts__item">
        <strong>{ section }</strong>
        <p>{ content.title } <br />{ sameMessage }</p>
        { this.renderAttributes(content) }
      </div>
    );
  }
}

export default NationalContactsContentItem;



// WEBPACK FOOTER //
// ./src/components/NationalContacts/NationalContactsContentItem.js